const toNumber = (val: string) =>
  Number.isNaN(Number.parseFloat(val)) ? 0 : Number.parseFloat(val);

export const sum = (data: any, accessor = (d: any) => d) =>
  Array.isArray(data) ? data.reduce((acc, curr) => acc + toNumber(accessor(curr)), 0) : 0;
